export class ManagedUser {
  roles: number[] = [];

  constructor(public policyId: number, public email: string, public firstName: string, public lastName: string, public role: number, public status = "Active") {
    this.policyId = policyId;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    if (role) this.roles = [role];
  }
}